// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Accordion-module__font-s-10___iBdCd {
  font-size: 10px !important;
}

.Accordion-module__font-s-12___AoEbe {
  font-size: 12px !important;
}

.Accordion-module__font-s-13___YtNuH {
  font-size: 13px !important;
}

.Accordion-module__font-s-14___IQR56 {
  font-size: 14px !important;
}

.Accordion-module__font-s-15___N4NBO {
  font-size: 15px !important;
}

.Accordion-module__font-s-16___CoCTF {
  font-size: 16px !important;
}

.Accordion-module__font-s-18___XGH8o {
  font-size: 18px !important;
}

.Accordion-module__font-s-20___J6TnY {
  font-size: 20px !important;
}

.Accordion-module__font-s-22___G2enw {
  font-size: 22px !important;
}

.Accordion-module__font-s-28___sn1iy {
  font-size: 28px !important;
}

.Accordion-module__font-w-400___fdGrU {
  font-weight: 400 !important;
}

.Accordion-module__font-w-500___dME1c {
  font-weight: 500 !important;
}

.Accordion-module__font-w-600___Zg12J {
  font-weight: 600 !important;
}

.Accordion-module__font-w-700___mt9LN {
  font-weight: 700 !important;
}

.Accordion-module__p-5___maV1C {
  padding: 5px !important;
}

.Accordion-module__p-12___lBZkT {
  padding: 12px !important;
}

.Accordion-module__p-16___zyye9 {
  padding: 16px !important;
}

.Accordion-module__p-30___JuGXy {
  padding: 30px !important;
}

.Accordion-module__p-b-0___qu9JK {
  padding-bottom: 0 !important;
}

.Accordion-module__p-b-5___y3SxX {
  padding-bottom: 5px !important;
}

.Accordion-module__p-b-10___aGcRz {
  padding-bottom: 10px !important;
}

.Accordion-module__p-b-12___T3D0C {
  padding-bottom: 12px !important;
}

.Accordion-module__p-b-16___L0CGW {
  padding-bottom: 16px !important;
}

.Accordion-module__p-b-18___vxgnQ {
  padding-bottom: 18px !important;
}

.Accordion-module__p-b-20___kTTGl {
  padding-bottom: 20px !important;
}

.Accordion-module__p-b-25___aVJLt {
  padding-bottom: 25px !important;
}

.Accordion-module__p-b-30___TrN0h {
  padding-bottom: 30px !important;
}

.Accordion-module__p-b-50___d7YxR {
  padding-bottom: 50px !important;
}

.Accordion-module__p-t-0___TzrJI {
  padding-top: 0 !important;
}

.Accordion-module__p-t-12___nyFGo {
  padding-top: 12px !important;
}

.Accordion-module__p-t-16___NwAYx {
  padding-top: 16px !important;
}

.Accordion-module__p-t-18___dmLP7 {
  padding-top: 18px !important;
}

.Accordion-module__p-t-20___Lwo7d {
  padding-top: 20px !important;
}

.Accordion-module__p-t-30___lfSgW {
  padding-top: 30px !important;
}

.Accordion-module__p-t-40___cdPRO {
  padding-top: 40px !important;
}

.Accordion-module__p-t-50___pKcg4 {
  padding-top: 50px !important;
}

.Accordion-module__p-l-20___DrFUT {
  padding-left: 20px !important;
}

.Accordion-module__p-l-30___wXIq5 {
  padding-left: 30px !important;
}

.Accordion-module__p-l-40___oM3TV {
  padding-left: 40px !important;
}

.Accordion-module__p-r-16___m4MQo {
  padding-right: 16px !important;
}

.Accordion-module__p-r-20___mBjEN {
  padding-right: 20px !important;
}

.Accordion-module__p-r-30___nRPfp {
  padding-right: 30px !important;
}

.Accordion-module__p-r-50___sfarF {
  padding-right: 50px !important;
}

.Accordion-module__p-r-60___Zwhqj {
  padding-right: 60px !important;
}

.Accordion-module__m-b-1___zw1Mj {
  margin-bottom: 1px !important;
}

.Accordion-module__m-b-2___twv0R {
  margin-bottom: 2px !important;
}

.Accordion-module__m-b-6___cSZh_ {
  margin-bottom: 6px !important;
}

.Accordion-module__m-b-8___pCOfA {
  margin-bottom: 8px !important;
}

.Accordion-module__m-b-10___Qhs_B {
  margin-bottom: 10px !important;
}

.Accordion-module__m-b-14___MtYt6 {
  margin-bottom: 14px !important;
}

.Accordion-module__m-b-16___k6RrC {
  margin-bottom: 16px !important;
}

.Accordion-module__m-b-20___l7aoq {
  margin-bottom: 20px !important;
}

.Accordion-module__m-b-22___n9Yka {
  margin-bottom: 22px !important;
}

.Accordion-module__m-b-24___jdHzM {
  margin-bottom: 24px !important;
}

.Accordion-module__m-b-30___Ms6MQ {
  margin-bottom: 30px !important;
}

.Accordion-module__m-b-32___uOB5l {
  margin-bottom: 32px !important;
}

.Accordion-module__m-b-40___pUEWU {
  margin-bottom: 40px !important;
}

.Accordion-module__m-t-2___lIJ8X {
  margin-top: 2px !important;
}

.Accordion-module__m-t-3___bLJKz {
  margin-top: 3px !important;
}

.Accordion-module__m-t-4___GyZDf {
  margin-top: 4px !important;
}

.Accordion-module__m-t-5___yZawQ {
  margin-top: 5px !important;
}

.Accordion-module__m-t-8___x1fm_ {
  margin-top: 8px !important;
}

.Accordion-module__m-t-10____FP1G {
  margin-top: 10px !important;
}

.Accordion-module__m-t-15___sd2_O {
  margin-top: 15px !important;
}

.Accordion-module__m-t-16___nxPE6 {
  margin-top: 16px !important;
}

.Accordion-module__m-t-20___dMJyh {
  margin-top: 20px !important;
}

.Accordion-module__m-t-22___qgMXX {
  margin-top: 22px !important;
}

.Accordion-module__m-t-30___mji7Q {
  margin-top: 30px !important;
}

.Accordion-module__m-t-32___KetDp {
  margin-top: 32px !important;
}

.Accordion-module__m-l-auto___lsYKd {
  margin-left: auto !important;
}

.Accordion-module__m-l-4___w9k77 {
  margin-left: 4px !important;
}

.Accordion-module__m-l-5___sCP0J {
  margin-left: 5px !important;
}

.Accordion-module__m-l-6___TcuY7 {
  margin-left: 6px !important;
}

.Accordion-module__m-l-8___R8thI {
  margin-left: 8px !important;
}

.Accordion-module__m-l-10___e4Yu1 {
  margin-left: 10px !important;
}

.Accordion-module__m-l-16___GfOtS {
  margin-left: 16px !important;
}

.Accordion-module__m-l-20____DAmk {
  margin-left: 20px !important;
}

.Accordion-module__m-l-24___lw_DL {
  margin-left: 24px !important;
}

.Accordion-module__m-l-30___ZgnuW {
  margin-left: 30px !important;
}

.Accordion-module__m-l-35___K3bgv {
  margin-left: 35px !important;
}

.Accordion-module__m-l-40___wFEmS {
  margin-left: 40px !important;
}

.Accordion-module__m-r-8___tURF0 {
  margin-right: 8px !important;
}

.Accordion-module__m-r-10___jVEha {
  margin-right: 10px !important;
}

.Accordion-module__m-r-16___zzGN7 {
  margin-right: 16px !important;
}

.Accordion-module__m-r-20___ND_vm {
  margin-right: 20px !important;
}

.Accordion-module__m-r-24___OlLeO {
  margin-right: 24px !important;
}

.Accordion-module__m-r-30___SWvYs {
  margin-right: 30px !important;
}

.Accordion-module__m-r-40___xrkyB {
  margin-right: 40px !important;
}

.Accordion-module__border-r-3___yE3sc {
  border-radius: 3px !important;
}

.Accordion-module__border-r-4___4Bgyy {
  border-radius: 4px !important;
}

.Accordion-module__border-r-6___vlIoC {
  border-radius: 6px !important;
}

.Accordion-module__border-r-10___QyynK {
  border-radius: 10px !important;
}

.Accordion-module__border-r-12___xAB7k {
  border-radius: 12px !important;
}

.Accordion-module__border-r-16___wk3JA {
  border-radius: 16px !important;
}

.Accordion-module__border-r-50___AyF6F {
  border-radius: 50% !important;
}

.Accordion-module__primary-border___INFFM {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Accordion-module__primary-border-b___zHGks {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Accordion-module__primary-border-t___PU8ej {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Accordion-module__primary-border-l___Cjbd2 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Accordion-module__primary-border-r___zvVxw {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Accordion-module__secondary-border___d1oiF {
  border: 1px solid #637768;
}

.Accordion-module__secondary-border-b___xVXT9 {
  border-bottom: 1px solid #637768;
}

.Accordion-module__secondary-border-t___lg_bX {
  border-top: 1px solid #637768;
}

.Accordion-module__secondary-border-l___NOmJb {
  border-left: 1px solid #637768;
}

.Accordion-module__secondary-border-r___ItAeV {
  border-right: 1px solid #637768;
}

.Accordion-module__gap-0___hMnjg {
  gap: 0 !important;
}

.Accordion-module__gap-2___muw_I {
  gap: 2px !important;
}

.Accordion-module__gap-4___AgbRh {
  gap: 4px !important;
}

.Accordion-module__gap-5___BzbdW {
  gap: 5px !important;
}

.Accordion-module__gap-6___SKSVt {
  gap: 6px !important;
}

.Accordion-module__gap-8___fy4ii {
  gap: 8px !important;
}

.Accordion-module__gap-10___ok86S {
  gap: 10px !important;
}

.Accordion-module__gap-12___k4Noc {
  gap: 12px !important;
}

.Accordion-module__gap-14___gj8oB {
  gap: 14px !important;
}

.Accordion-module__gap-16___sHpiU {
  gap: 16px !important;
}

.Accordion-module__gap-18___mHwMI {
  gap: 18px !important;
}

.Accordion-module__gap-20___cDp1f {
  gap: 20px !important;
}

.Accordion-module__gap-24___x4dlI {
  gap: 24px !important;
}

.Accordion-module__gap-26___ZP4oU {
  gap: 26px !important;
}

.Accordion-module__gap-30___nQ2g6 {
  gap: 30px !important;
}

.Accordion-module__gap-32___VxgSm {
  gap: 32px !important;
}

.Accordion-module__gap-40___M5qNH {
  gap: 40px !important;
}

.Accordion-module__gap-50___NijSZ {
  gap: 50px !important;
}

.Accordion-module__flex-1___O4YUf {
  flex: 1;
}

.Accordion-module__flex-none___Svt2X {
  flex: none !important;
}

.Accordion-module__flex-column____Nkgc {
  display: flex;
  flex-direction: column !important;
}

.Accordion-module__flex-row___eAs12 {
  display: flex;
  flex-direction: row !important;
}

.Accordion-module__vertically-centered___NMaob {
  display: flex;
  align-items: center !important;
}

.Accordion-module__horizontally-centered___BuZ4w {
  display: flex;
  justify-content: center !important;
}

.Accordion-module__horizontally-end____NCU5 {
  display: flex;
  justify-content: end !important;
}

.Accordion-module__vertically-start___ltKuH {
  display: flex;
  align-items: start !important;
}

.Accordion-module__space-between___VWbwq {
  display: flex;
  justify-content: space-between !important;
}

.Accordion-module__flex-wrap___uQNBc {
  flex-wrap: wrap !important;
}

.Accordion-module__height-100___HrsEG {
  height: 100%;
}

.Accordion-module__width-50___sLzNv {
  width: 50% !important;
}

.Accordion-module__width-100___vh86g {
  width: 100%;
}

.Accordion-module__cursor-pointer___ttjDL {
  cursor: pointer;
}

.Accordion-module__cursor-not-allowed___FmHMl {
  cursor: not-allowed !important;
}

.Accordion-module__absolute-centered___UFqki {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Accordion-module__absolute___Laxur {
  position: absolute;
}

.Accordion-module__relative___jFaLn {
  position: relative;
}

.Accordion-module__fixed___C8PuJ {
  position: fixed;
}

.Accordion-module__visible___uwm3a {
  opacity: 1;
}

.Accordion-module__invisible___LHrvx {
  opacity: 0;
}

.Accordion-module__col-90___XK0XV {
  width: 90% !important;
}

.Accordion-module__col-auto___bWdwf {
  width: auto !important;
}

.Accordion-module__medical-tabs___BjMh3 {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Accordion-module__medical-table-new___uTLi9 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Accordion-module__medical-table-new___uTLi9:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Accordion-module__medical-table-new___uTLi9::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Accordion-module__medical-table-new___uTLi9::-webkit-scrollbar-track {
  display: none;
}
.Accordion-module__medical-table-new___uTLi9.Accordion-module__no-pagination___dhSZ_ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Accordion-module__medical-table-new___uTLi9.Accordion-module__no-pagination___dhSZ_:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Accordion-module__medical-table-new___uTLi9.Accordion-module__no-pagination___dhSZ_::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Accordion-module__medical-table-new___uTLi9.Accordion-module__no-pagination___dhSZ_::-webkit-scrollbar-track {
  display: none;
}

.Accordion-module__medical-table-empty___tTztF {
  padding: 14px 40px !important;
}

.Accordion-module__icon-btn___Z6vC2 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Accordion-module__search-icon___Sz0iH {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Accordion-module__disable-select___jWBCw {
  user-select: none;
}

.Accordion-module__break-word___KWNdX {
  word-break: break-word;
}

.Accordion-module__popup-clear-btn___DoTXa {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Accordion-module__scroll-m-b-20___EAhVH {
  scroll-margin-bottom: 20px;
}

.Accordion-module__container___kDn_l {
  color: #375844;
  border-radius: 4px 4px 0px 0px;
}
.Accordion-module__container___kDn_l .Accordion-module__arrow___OA5WY {
  transform: rotate(-90deg);
  transition: transform 0.4s ease;
}
.Accordion-module__container___kDn_l .Accordion-module__arrow___OA5WY.Accordion-module__rotate___PUIFC {
  transform: rotate(0deg);
}
.Accordion-module__container___kDn_l .Accordion-module__content___OWb8y {
  padding: 0 16px 16px 16px;
}
.Accordion-module__container___kDn_l .Accordion-module__instructions___ZFtlq {
  color: #637768;
  width: 90%;
}
.Accordion-module__container___kDn_l .Accordion-module__editButton___JA_dT {
  padding: 16px;
  min-width: auto !important;
}
.Accordion-module__container___kDn_l .Accordion-module__editButton___JA_dT > img {
  width: 18px;
  height: 18px;
}
.Accordion-module__container___kDn_l .Accordion-module__editButton___JA_dT > span {
  font-size: 14px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Accordion/Accordion.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,8BAAA;AA8pBF;AA5pBE;EACE,yBAAA;EACA,+BAAA;AA8pBJ;AA5pBI;EACE,uBAAA;AA8pBN;AA1pBE;EACE,yBAAA;AA4pBJ;AAzpBE;EACE,cAAA;EACA,UAAA;AA2pBJ;AAxpBE;EACE,aAAA;EACA,0BAAA;AA0pBJ;AAxpBI;EACE,WAAA;EACA,YAAA;AA0pBN;AAvpBI;EACE,0BAAA;AAypBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  border-radius: 4px 4px 0px 0px;\n\n  .arrow {\n    transform: rotate(-90deg);\n    transition: transform 0.4s ease;\n\n    &.rotate {\n      transform: rotate(0deg);\n    }\n  }\n\n  .content {\n    padding: 0 16px 16px 16px;\n  }\n\n  .instructions {\n    color: get-color(greenNew, medium-dark);\n    width: 90%;\n  }\n\n  .editButton {\n    padding: 16px;\n    min-width: auto !important;\n\n    & > img {\n      width: 18px;\n      height: 18px;\n    }\n\n    & > span {\n      font-size: 14px !important;\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Accordion-module__font-s-10___iBdCd`,
	"fontS12": `Accordion-module__font-s-12___AoEbe`,
	"fontS13": `Accordion-module__font-s-13___YtNuH`,
	"fontS14": `Accordion-module__font-s-14___IQR56`,
	"fontS15": `Accordion-module__font-s-15___N4NBO`,
	"fontS16": `Accordion-module__font-s-16___CoCTF`,
	"fontS18": `Accordion-module__font-s-18___XGH8o`,
	"fontS20": `Accordion-module__font-s-20___J6TnY`,
	"fontS22": `Accordion-module__font-s-22___G2enw`,
	"fontS28": `Accordion-module__font-s-28___sn1iy`,
	"fontW400": `Accordion-module__font-w-400___fdGrU`,
	"fontW500": `Accordion-module__font-w-500___dME1c`,
	"fontW600": `Accordion-module__font-w-600___Zg12J`,
	"fontW700": `Accordion-module__font-w-700___mt9LN`,
	"p5": `Accordion-module__p-5___maV1C`,
	"p12": `Accordion-module__p-12___lBZkT`,
	"p16": `Accordion-module__p-16___zyye9`,
	"p30": `Accordion-module__p-30___JuGXy`,
	"pB0": `Accordion-module__p-b-0___qu9JK`,
	"pB5": `Accordion-module__p-b-5___y3SxX`,
	"pB10": `Accordion-module__p-b-10___aGcRz`,
	"pB12": `Accordion-module__p-b-12___T3D0C`,
	"pB16": `Accordion-module__p-b-16___L0CGW`,
	"pB18": `Accordion-module__p-b-18___vxgnQ`,
	"pB20": `Accordion-module__p-b-20___kTTGl`,
	"pB25": `Accordion-module__p-b-25___aVJLt`,
	"pB30": `Accordion-module__p-b-30___TrN0h`,
	"pB50": `Accordion-module__p-b-50___d7YxR`,
	"pT0": `Accordion-module__p-t-0___TzrJI`,
	"pT12": `Accordion-module__p-t-12___nyFGo`,
	"pT16": `Accordion-module__p-t-16___NwAYx`,
	"pT18": `Accordion-module__p-t-18___dmLP7`,
	"pT20": `Accordion-module__p-t-20___Lwo7d`,
	"pT30": `Accordion-module__p-t-30___lfSgW`,
	"pT40": `Accordion-module__p-t-40___cdPRO`,
	"pT50": `Accordion-module__p-t-50___pKcg4`,
	"pL20": `Accordion-module__p-l-20___DrFUT`,
	"pL30": `Accordion-module__p-l-30___wXIq5`,
	"pL40": `Accordion-module__p-l-40___oM3TV`,
	"pR16": `Accordion-module__p-r-16___m4MQo`,
	"pR20": `Accordion-module__p-r-20___mBjEN`,
	"pR30": `Accordion-module__p-r-30___nRPfp`,
	"pR50": `Accordion-module__p-r-50___sfarF`,
	"pR60": `Accordion-module__p-r-60___Zwhqj`,
	"mB1": `Accordion-module__m-b-1___zw1Mj`,
	"mB2": `Accordion-module__m-b-2___twv0R`,
	"mB6": `Accordion-module__m-b-6___cSZh_`,
	"mB8": `Accordion-module__m-b-8___pCOfA`,
	"mB10": `Accordion-module__m-b-10___Qhs_B`,
	"mB14": `Accordion-module__m-b-14___MtYt6`,
	"mB16": `Accordion-module__m-b-16___k6RrC`,
	"mB20": `Accordion-module__m-b-20___l7aoq`,
	"mB22": `Accordion-module__m-b-22___n9Yka`,
	"mB24": `Accordion-module__m-b-24___jdHzM`,
	"mB30": `Accordion-module__m-b-30___Ms6MQ`,
	"mB32": `Accordion-module__m-b-32___uOB5l`,
	"mB40": `Accordion-module__m-b-40___pUEWU`,
	"mT2": `Accordion-module__m-t-2___lIJ8X`,
	"mT3": `Accordion-module__m-t-3___bLJKz`,
	"mT4": `Accordion-module__m-t-4___GyZDf`,
	"mT5": `Accordion-module__m-t-5___yZawQ`,
	"mT8": `Accordion-module__m-t-8___x1fm_`,
	"mT10": `Accordion-module__m-t-10____FP1G`,
	"mT15": `Accordion-module__m-t-15___sd2_O`,
	"mT16": `Accordion-module__m-t-16___nxPE6`,
	"mT20": `Accordion-module__m-t-20___dMJyh`,
	"mT22": `Accordion-module__m-t-22___qgMXX`,
	"mT30": `Accordion-module__m-t-30___mji7Q`,
	"mT32": `Accordion-module__m-t-32___KetDp`,
	"mLAuto": `Accordion-module__m-l-auto___lsYKd`,
	"mL4": `Accordion-module__m-l-4___w9k77`,
	"mL5": `Accordion-module__m-l-5___sCP0J`,
	"mL6": `Accordion-module__m-l-6___TcuY7`,
	"mL8": `Accordion-module__m-l-8___R8thI`,
	"mL10": `Accordion-module__m-l-10___e4Yu1`,
	"mL16": `Accordion-module__m-l-16___GfOtS`,
	"mL20": `Accordion-module__m-l-20____DAmk`,
	"mL24": `Accordion-module__m-l-24___lw_DL`,
	"mL30": `Accordion-module__m-l-30___ZgnuW`,
	"mL35": `Accordion-module__m-l-35___K3bgv`,
	"mL40": `Accordion-module__m-l-40___wFEmS`,
	"mR8": `Accordion-module__m-r-8___tURF0`,
	"mR10": `Accordion-module__m-r-10___jVEha`,
	"mR16": `Accordion-module__m-r-16___zzGN7`,
	"mR20": `Accordion-module__m-r-20___ND_vm`,
	"mR24": `Accordion-module__m-r-24___OlLeO`,
	"mR30": `Accordion-module__m-r-30___SWvYs`,
	"mR40": `Accordion-module__m-r-40___xrkyB`,
	"borderR3": `Accordion-module__border-r-3___yE3sc`,
	"borderR4": `Accordion-module__border-r-4___4Bgyy`,
	"borderR6": `Accordion-module__border-r-6___vlIoC`,
	"borderR10": `Accordion-module__border-r-10___QyynK`,
	"borderR12": `Accordion-module__border-r-12___xAB7k`,
	"borderR16": `Accordion-module__border-r-16___wk3JA`,
	"borderR50": `Accordion-module__border-r-50___AyF6F`,
	"primaryBorder": `Accordion-module__primary-border___INFFM`,
	"primaryBorderB": `Accordion-module__primary-border-b___zHGks`,
	"primaryBorderT": `Accordion-module__primary-border-t___PU8ej`,
	"primaryBorderL": `Accordion-module__primary-border-l___Cjbd2`,
	"primaryBorderR": `Accordion-module__primary-border-r___zvVxw`,
	"secondaryBorder": `Accordion-module__secondary-border___d1oiF`,
	"secondaryBorderB": `Accordion-module__secondary-border-b___xVXT9`,
	"secondaryBorderT": `Accordion-module__secondary-border-t___lg_bX`,
	"secondaryBorderL": `Accordion-module__secondary-border-l___NOmJb`,
	"secondaryBorderR": `Accordion-module__secondary-border-r___ItAeV`,
	"gap0": `Accordion-module__gap-0___hMnjg`,
	"gap2": `Accordion-module__gap-2___muw_I`,
	"gap4": `Accordion-module__gap-4___AgbRh`,
	"gap5": `Accordion-module__gap-5___BzbdW`,
	"gap6": `Accordion-module__gap-6___SKSVt`,
	"gap8": `Accordion-module__gap-8___fy4ii`,
	"gap10": `Accordion-module__gap-10___ok86S`,
	"gap12": `Accordion-module__gap-12___k4Noc`,
	"gap14": `Accordion-module__gap-14___gj8oB`,
	"gap16": `Accordion-module__gap-16___sHpiU`,
	"gap18": `Accordion-module__gap-18___mHwMI`,
	"gap20": `Accordion-module__gap-20___cDp1f`,
	"gap24": `Accordion-module__gap-24___x4dlI`,
	"gap26": `Accordion-module__gap-26___ZP4oU`,
	"gap30": `Accordion-module__gap-30___nQ2g6`,
	"gap32": `Accordion-module__gap-32___VxgSm`,
	"gap40": `Accordion-module__gap-40___M5qNH`,
	"gap50": `Accordion-module__gap-50___NijSZ`,
	"flex1": `Accordion-module__flex-1___O4YUf`,
	"flexNone": `Accordion-module__flex-none___Svt2X`,
	"flexColumn": `Accordion-module__flex-column____Nkgc`,
	"flexRow": `Accordion-module__flex-row___eAs12`,
	"verticallyCentered": `Accordion-module__vertically-centered___NMaob`,
	"horizontallyCentered": `Accordion-module__horizontally-centered___BuZ4w`,
	"horizontallyEnd": `Accordion-module__horizontally-end____NCU5`,
	"verticallyStart": `Accordion-module__vertically-start___ltKuH`,
	"spaceBetween": `Accordion-module__space-between___VWbwq`,
	"flexWrap": `Accordion-module__flex-wrap___uQNBc`,
	"height100": `Accordion-module__height-100___HrsEG`,
	"width50": `Accordion-module__width-50___sLzNv`,
	"width100": `Accordion-module__width-100___vh86g`,
	"cursorPointer": `Accordion-module__cursor-pointer___ttjDL`,
	"cursorNotAllowed": `Accordion-module__cursor-not-allowed___FmHMl`,
	"absoluteCentered": `Accordion-module__absolute-centered___UFqki`,
	"absolute": `Accordion-module__absolute___Laxur`,
	"relative": `Accordion-module__relative___jFaLn`,
	"fixed": `Accordion-module__fixed___C8PuJ`,
	"visible": `Accordion-module__visible___uwm3a`,
	"invisible": `Accordion-module__invisible___LHrvx`,
	"col90": `Accordion-module__col-90___XK0XV`,
	"colAuto": `Accordion-module__col-auto___bWdwf`,
	"medicalTabs": `Accordion-module__medical-tabs___BjMh3`,
	"medicalTableNew": `Accordion-module__medical-table-new___uTLi9`,
	"noPagination": `Accordion-module__no-pagination___dhSZ_`,
	"medicalTableEmpty": `Accordion-module__medical-table-empty___tTztF`,
	"iconBtn": `Accordion-module__icon-btn___Z6vC2`,
	"searchIcon": `Accordion-module__search-icon___Sz0iH`,
	"disableSelect": `Accordion-module__disable-select___jWBCw`,
	"breakWord": `Accordion-module__break-word___KWNdX`,
	"popupClearBtn": `Accordion-module__popup-clear-btn___DoTXa`,
	"scrollMB20": `Accordion-module__scroll-m-b-20___EAhVH`,
	"container": `Accordion-module__container___kDn_l`,
	"arrow": `Accordion-module__arrow___OA5WY`,
	"rotate": `Accordion-module__rotate___PUIFC`,
	"content": `Accordion-module__content___OWb8y`,
	"instructions": `Accordion-module__instructions___ZFtlq`,
	"editButton": `Accordion-module__editButton___JA_dT`
};
module.exports = ___CSS_LOADER_EXPORT___;
